module.exports = __webpack_public_path__ + "media/images/menu/callisto-7da9fe46c323630045e3fd5c00d3ff37.jpg";